// removed by extract-text-webpack-plugin
module.exports = {"title":"_2NMGB7aNRmTEIaIpeaCTfy","subTitle":"_22WWqamlH0aIgUQ0pXZRNT","buttonNew":"_1pgltgJQhJD26I2p5jRNHR","filters":"_228reALd6mW0RI1rkyExSw","filter":"_3TZ1k0CV8N9JlklLbGLWkg","label":"_1tfhJAZ525dBdToBJGl_QM","item":"OdSq1d8nElsAkNtf49mce","table":"k7UgO8AhvoetSzuGG74EC","tags":"_3TDh4A5P_PRGBTzxjnrZdR"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Production/style.scss
// module id = 1245
// module chunks = 0